import React from 'react';
import PropTypes from 'prop-types'

const FileChooser = ({ name, title, onChange, isRequired, errorMessage, acceptTypes }) => {

    return (
        <div className="mb-3">
            {
                title && title.trim().length > 0 &&
                <label htmlFor={name}>{title}</label>
            }
            <input type="file" className="form-control-file" id={name} name={name} onChange={onChange} required={isRequired} accept={acceptTypes} />
            <div className="invalid-feedback">
                {errorMessage}
            </div>
        </div>
    );
};

FileChooser.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    onChange: PropTypes.func,
    isRequired: PropTypes.bool,
    errorMessage: PropTypes.string,
    acceptTypes: PropTypes.string
};

export default FileChooser;